export enum NotificationTypeEnum {
	Announcement = 'announcement',
	Course = 'course',
	Quiz = 'quiz',
	CLASSROOM_JOIN = 'CLASSROOM_JOIN',
	QUIZ_ATTEMPT = 'QUIZ_ATTEMPT',
	AI_COURSE = 'SYLLABUS_GENERATED',
	AI_COURSE_FAILED = 'SYLLABUS_GENERATION_FAILED',
	Mentor_session = 'mentor_session',
	SUBSCRIPTION_ACTIVATION = 'subscription_activation',
	APPOINTMENT_ACCEPTED = 'appointment_accepted',
	APPOINTMENT_REJECTED = 'appointment_rejected',
	Job = 'job',
	JobApplication = 'job_application',
	Assessment = 'assessment',
	Interview = 'interview',
	HiringComplete = 'hiring_complete',
	MockAssessment = 'mock_assessment',
	MockInterview = 'mock_interview'
}